import { NgModule, ModuleWithProviders } from '@angular/core'
import { CommonModule } from '@angular/common'
import { MessageService } from './services/message.service'

@NgModule({
  imports: [CommonModule]
})
export class MessageModule {
  static forRoot(): ModuleWithProviders<MessageModule> {
    return {
      ngModule: MessageModule,
      providers: [MessageService]
    }
  }
}
